import React from 'react';
import styled from 'styled-components';

import { Flex } from '../atom/Layout';
import { AnchorToKakaoCs } from '../atom/Anchor';
import { ReactComponent as ChatSvg } from '../../../lib/image/icons/chat.svg';

const FloatingButton = () => {
  return (
    <AnchorToKakaoCs>
      <Container>
        <ChatSvg />
      </Container>
    </AnchorToKakaoCs>
  );
};

export default FloatingButton;

const Container = styled(Flex)`
  position: fixed;
  bottom: 4.5rem;
  right: 0.625rem;
  z-index: 99;

  svg {
    width: 3rem;
    height: auto;
  }
`;
